import { FormControl, InputLabel, Select, MenuItem, InputAdornment } from '@mui/material';
import { ChildCare } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface ChildrenSelectorProps {
  value: number;
  onChange: (children: number) => void;
  label?: string;
  disabled?: boolean;
}

export function ChildrenSelector({
  value,
  onChange,
  label,
  disabled = false,
}: ChildrenSelectorProps) {
  const { t } = useTranslation();
  const displayLabel = label ?? t('childrenSelector.label');

  const options = Array.from({ length: 11 }, (_, i) => i); // 0-10 children

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel>{displayLabel}</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        label={displayLabel}
        startAdornment={
          <InputAdornment position="start">
            <ChildCare />
          </InputAdornment>
        }
      >
        {options.map((num) => (
          <MenuItem key={num} value={num}>
            {num === 0 ? t('childrenSelector.noChildren') : t('childrenSelector.child', { count: num })}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
